// hooks/useChatListWebSocket.js
import { useEffect, useCallback, useRef } from 'react';
import { useSimpleWebSocket } from './useSimpleWebSocket';

export const useChatListWebSocket = (userId, onNewMessage, onMessageRead, onTyping) => {
  const { isConnected, subscribeToGlobal } = useSimpleWebSocket();
  const userIdRef = useRef(userId);
  const lastMessageRef = useRef(null);

  useEffect(() => {
    userIdRef.current = userId;
  }, [userId]);

  // Handle incoming WebSocket messages
  const handleMessage = useCallback((data) => {
    if (!userIdRef.current) return;

    // console.log('📨 Chat list received:', data.type);

    switch (data.type) {
      case 'new_message':
        // Only process if message is for current user's conversations
        if (data.message && onNewMessage) {
          // Check if this message belongs to a conversation involving current user
          // The server should handle this filtering, but we can add an extra check
          const message = data.message;
          
          // Optional: Add validation that message belongs to current user
          // if (message.sender_id === userIdRef.current || message.receiver_id === userIdRef.current) {
            onNewMessage(message);
          // }
        }
        break;

      case 'messages_read':
        if (data.reader_id === userIdRef.current && onMessageRead) {
          onMessageRead(data.conversation_id, data.reader_id);
        }
        break;

      case 'typing':
        if (data.user_id !== userIdRef.current && onTyping) {
          onTyping(data.conversation_id, data.user_id, data.is_typing);
        }
        break;

      default:
        // Ignore other message types
        break;
    }
  }, [onNewMessage, onMessageRead, onTyping]);

  // Subscribe to global messages when connected
  useEffect(() => {
    if (!isConnected || !userId) return;

    // console.log('🌍 Subscribing to global messages for chat list');
    const unsubscribe = subscribeToGlobal(handleMessage);

    return () => {
      // console.log('🌍 Unsubscribing from global messages');
      if (unsubscribe) unsubscribe();
    };
  }, [isConnected, userId, subscribeToGlobal, handleMessage]);

  // Return connection status for UI feedback
  return {
    isConnected,
    isRealtime: isConnected
  };
};